import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useCallback,
  useImperativeHandle,
  useState,
} from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Color } from "../../../../Form/Button";
import TextField from "../../../../Form/Input";
import { ActionButtonProps } from "../../../ActionButtons";
import Modal from "../../../Modal";
import useStyles from "./styles";

export interface CommentModalHandles {
  open: (sscc: string) => void;
  close: () => void;
}
interface CommentModalProps {
  closeModal?: () => void;
  onSubmit: (sscc: string, comment: string) => void;
}

const CommentModal: ForwardRefRenderFunction<CommentModalHandles, CommentModalProps> = (
  props,
  ref
) => {
  const classes = useStyles();
  const { closeModal, onSubmit } = props;
  const { t: translate } = useTranslation();

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [comment, setComment] = useState<string>("");
  const [sscc, setSscc] = useState<string>("");

  const open = useCallback((sscc: string) => {
    setOpenModal(true);
    setSscc(sscc);
  }, []);
  const close = useCallback(() => {
    setOpenModal(false);
    setComment("");
    setSscc("");
  }, []);

  useImperativeHandle(ref, () => ({
    open,
    close,
  }));

  const onClose = () => {
    if (closeModal) closeModal();
    close();
  };

  const onSave = () => {
    onSubmit(sscc, comment);
    onClose();
  };

  const actionButtonProps: ActionButtonProps = {
    textSave: translate("add"),
    textCancel: translate("cancel"),
    customColorCancel: Color.CANCEL,
    customColorSave: Color.SUCCESS,
    onSave,
    onCancel: onClose,
  };

  return (
    <Modal
      title={translate("newComment")}
      open={openModal}
      handleClose={onClose}
      className={classes.paper}
      showActionButtons
      actionButtonProps={actionButtonProps}
    >
      <Grid container direction="column">
        <Grid item xs={12}>
          <TextField
            name="newComment"
            multiline
            minRows={3}
            maxRows={5}
            maxLength={250}
            placeholder={translate("typeAComment")}
            value={comment}
            required
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setComment(event?.target.value);
            }}
          />
        </Grid>
      </Grid>
    </Modal>
  );
};

export default forwardRef(CommentModal);
